import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=09ef7f5a&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"
import style0 from "./Documents.vue?vue&type=style&index=0&id=09ef7f5a&lang=scss&scoped=true"
import style1 from "./Documents.vue?vue&type=style&index=1&id=09ef7f5a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ef7f5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09ef7f5a')) {
      api.createRecord('09ef7f5a', component.options)
    } else {
      api.reload('09ef7f5a', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=09ef7f5a&scoped=true", function () {
      api.rerender('09ef7f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/Tabs/Documents.vue"
export default component.exports